import JSXComponent from "../../../dist/jsx-render/JSXComponent";
import dom, { Fragment } from "../../../dist/jsx-render/dom";
import { DynPopup } from "../../Components/DynPopup";
import { TextComponent } from "../../Components/TextComponent";
import { IDocumentInfo } from "../../Model/IDocumentInfo";
import { MsoTable } from "../../Controls/Table/MsoTable";
import { app } from "../../Frame/App";
import { Popup } from "../../Areas/Leitplanke/Project/Popup";
import { DynamicController } from "../../Controls/Dynamic/DynamicController";
import { DropDownComponent, DropDownComponentProps } from "../../Components/DropDownComponent";

export type PopupEditDocumentProps = {
    model: IDocumentInfo;
    parentTable?: MsoTable;
    onSave?: (model: IDocumentInfo) => void;
    onDelete?: any;

    isLink?: boolean;
    disabled?: boolean;
    allowMove?: boolean;
    afterMoveEvent?: (model: IDocumentInfo) => void;
}

export class PopupEditDocument extends JSXComponent {
    props: PopupEditDocumentProps;
    constructor(props: PopupEditDocumentProps) { super(props); }

    private documentNewFieldId: number;

    element: HTMLElement;
    getElement = () => {

        // This should only happen, when the popup is opnend in a measure.
        let moveDocumentsDropdown: DropDownComponent = null;
        if (this.props.allowMove && this.props.model.id != 0) {
            let hiddenDocumentFields = document.getElementById("jsonDocumentFields") as HTMLInputElement;
            if (hiddenDocumentFields) {
                try {
                    let otherDocumentFields = JSON.parse(hiddenDocumentFields.value);

                    console.log(otherDocumentFields);

                    let dropdownProps: DropDownComponentProps = {
                        displayProperty: "text",
                        valueProperty: "id",
                        id: app.createRadomizedLetters(10),
                        addEmptyItem: false,
                        disableSort: true,
                        selectedValue: this.props.model.fieldId,
                        infoText: Resources.Common.moveDocumentInfo,
                        items: otherDocumentFields,
                        name: Resources.Common.moveDocument,
                        onChange: (control: DropDownComponent) => {
                            let newValue = Number(control.getValue());
                            if (newValue && newValue != this.props.model.fieldId) {
                                // The selected field has changed
                                this.props.model.newFieldId = newValue;
                            }
                        }
                    }

                    moveDocumentsDropdown = new DropDownComponent(dropdownProps);

                } catch (err) {
                    console.log(err);
                }
            }
        }


        let element = <DynPopup showCloseButton={true}
            showCancelButton={true}
            showSaveButton={true}
            showDeleteButton={true}
            onSave={this.onSaveClick}
            onDelete={this.onDeleteClick}
            size="fit"
            title={Resources.Common.editDocument}
            disabled={this.props.disabled}
            footer={
                <div class="d-flex flex-column mr-auto">
                    {(this.props.model.date && this.props.model.userName)
                        ? <span class="blockFinishInfo">{`${Resources.Common.createdOn} ${this.props.model.date} ${Resources.Common.by} ${this.props.model.userName} `}</span>
                        : []}
                    {(this.props.model.modifyDate && this.props.model.modifyUserName)
                        ? <span class="blockFinishInfo">{`${Resources.Common.editedOn} ${this.props.model.modifyDate} ${Resources.Common.by} ${this.props.model.modifyUserName} `}</span>
                        : []}
                </div>
            }
        >
            <div className="container">
                <TextComponent model={this.props.model}
                    field="link"
                    name={Resources.Begriffe.link}
                    additionalCssClasses="link-control"
                    required={true}
                    placeholder={Resources.Begriffe.linkInput}
                />

                {this.props.isLink ?
                    <TextComponent model={this.props.model}
                        field="fileName"
                        name={Resources.Begriffe.linkName}
                        additionalCssClasses="file-name"
                        required={true}
                        placeholder={Resources.Begriffe.linkNameInput}
                    />
                    :
                        <TextComponent model={this.props.model}
                        field="fileName"
                        name={Resources.Begriffe.fileName}
                        additionalCssClasses="file-name"
                        required={true}
                        placeholder={Resources.Begriffe.fileNameInput}
                    />
                }

                <TextComponent model={this.props.model}
                    field="annotation"
                    textarea={true}
                    lines={2}
                    name={Resources.Common.annotation}
                    placeholder={Resources.Begriffe.annotationInput}
                />

                {!app.isVetterStrategy ? <TextComponent model={this.props.model}
                    field="comment"
                    textarea={true}
                    name={Resources.Common.comment}
                    placeholder={Resources.Begriffe.commentInput}
                    lines={2} /> :
                    []
                }

                {this.props.allowMove === true && moveDocumentsDropdown
                    ? moveDocumentsDropdown.render()
                    : <Fragment>
                        <div className="form-group">
                            <label className="form-label">{Resources.Massnahme.status}</label>
                            <div className="info-text">
                                {this.props.model.blockName}
                            </div>
                        </div>
                        <div className="form-group">
                            <label className="form-label">{Resources.Common.field}</label>
                            <div className="info-text">
                                {this.props.model.fieldName}
                            </div>
                        </div>
                    </Fragment>}
            </div>

        </DynPopup>;

        return element;
    }

    render() {
        this.element = this.getElement();

        if (this.props.model.link) {
            this.props.isLink = true;
        }

        if (this.props.isLink) {
            let inputFileName = this.element.querySelector(".file-name input") as HTMLInputElement;
            /* inputFileName.disabled = true;*/
        } else {
            let inputFileName = this.element.querySelector(".link-control input") as HTMLInputElement;
            if (inputFileName) {
                inputFileName.disabled = true;
            }
        }

        return this.element;
    }

    onDeleteClick = (event: MouseEvent): boolean => {
        $.ajax({
            url: app.resolveUrl(`~/api/documents/canDelete/${this.props.model.measureId}/${this.props.model.templateFieldId}`),
            method: "GET",
            success: (response) => {
                if (response === true) {
                    if (confirm(Resources.Massnahme.documentDeleteConfirmation)) {
                        $.get(app.resolveUrl("~/api/documents/delete/" + this.props.model.id))
                            .done((response) => {
                                // close Popup
                                app.destroyDomElements(this.element);

                                if (this.props.onDelete) {
                                    this.props.onDelete(this.props.model.id);
                                }

                            })
                            .fail((response) => {
                                alert(response.statusText + ": " + response.responseText);
                            });
                    }
                } else {
                    document.body.appendChild(
                        <DynPopup showOkButton={true}
                            size="dialog"
                            title={Resources.Common.information}>
                            {Resources.Massnahme.documentDeleteNoPermission}
                        </DynPopup>
                    );
                }
            },
            error: (err) => {
                console.log(err);
            }
        });

        return false;
    }

    onSaveClick = (event: MouseEvent): boolean => {
        if (!this.props.model.fileName && !this.props.model.link) {
            alert(Resources.Common.documentValidationFileLink);
            return false;
        }

        let url: string;
        if (this.props.model.id == 0) {
            url = `~/api/documents/addLink/${this.props.model.measureId}/${this.props.model.templateFieldId}`;
        } else {
            url = "~/api/documents/update";
        }

        $.ajax({
            url: app.resolveUrl(url),
            method: "POST",
            data: JSON.stringify(this.props.model),
            dataType: "json",
            contentType: "application/json",
            success: (response) => {

                if (response.message == "success") {
                    this.props.model = (response.documentInfo as IDocumentInfo);
                }

                // close Popup
                app.destroyDomElements(this.element);

                if (this.props.parentTable) {
                    this.props.parentTable.updateRowFromModel(this.props.model, true);
                }

                // Update DocumentsControl
                if (this.props.model.fileName) {
                    let docRow = document.querySelector(`.doc-row[data-id='${this.props.model.id}']`) as HTMLDivElement;
                    if (docRow) {
                        let nameElement = docRow.querySelector(".doc-name") as HTMLDivElement;
                        nameElement.firstChild.nodeValue = this.props.model.fileName;
                    }
                }

                if (this.props.onSave) {
                    this.props.onSave(this.props.model);
                }

                if (this.props.afterMoveEvent && this.props.model.newFieldId && this.props.model.newFieldId != this.props.model.fieldId) {
                    this.props.afterMoveEvent(this.props.model);
                }
            },
            error: (err) => {
                console.log(err);
                alert(Resources.Common.errEditDocument);
                app.destroyDomElements(this.element);
            }
        });

        return false;
    }


}